<template>
  <div>
  <el-dialog :title="$t('title.takeDeliveryOfGoods')" :visible.sync="dialogVisible" :custom-class="dialogClass" :close-on-click-modal='false' :lock-scroll="false" :before-close="closeDialog" v-loading="loading">
<!-- 修改收货地址  -->
    <div class='checkout_box'>
      <h3>{{$t('base.shipTo')}}<span class="text_blue"  @click="addChange('','new')" >+{{ $t('base.addNewAddress') }}</span></h3>
      <ul class="address_list" >
        <li v-for="(item,index) in address" v-if="address.length>0" :class="{'on':isAddressId==item.Id}" @click='(isAddressId=item.Id,myAddress=item)'>
          <div class="choose_address">
            <div class="on_Default" v-if="item.IsDefault">{{$t('base.default')}}</div>
            <div>
            <span>{{item.UserName}}</span>
            ({{item.Country}})
            </div>
            <div class="line_txt2" :title="showAddress(item)">
              <span>{{item.StreetAddress !=null ? item.StreetAddress+', ':''}}</span>
              <span v-if="item.StreetAddress2 !=null&&item.StreetAddress2!=''">{{item.StreetAddress2 !=null&&item.StreetAddress2!='' ? item.StreetAddress2+', ':''}}</span>
              <span>{{item.City !=null ? item.City+', ':''}}</span>
              <span>{{item.StateCode !=null ? item.StateCode+', ':''}}</span>
              <span>{{item.ZipCode}}</span>
            </div>
            <div>{{item.Phone}}<span class="change text_blue chage_address"  @click="addChange(item,index)">{{$t('base.edit')}}</span></div>
          </div>
        </li>
      </ul>
    </div>
<!--  -->
  <div>
      <div class="formTitle">{{$t('title.parcelInformationContent')}}</div>
      <el-form class="parcelInformation" :model="passForm" :rules="rules" ref="passForm">
        <div>
          <div class="formLabel">{{$t('base.productDetails')}}</div>
          <el-form-item>
            <el-input class="newTaxInput taxDeclaration" disabled v-model="passForm.CustomDetail" ></el-input>
          </el-form-item>
        </div>
        <br>
        <div>
          <div class="formLabel">{{$t('base.quantity')}}</div>
          <el-form-item prop="CustomCommodityCount">
            
            <el-input class="newTaxInput taxDeclaration" v-model="passForm.CustomCommodityCount" oninput="value=value.replace(/^\D*(\d*(?:\\d{0,0})?).*$/g, '$1')" :placeholder="$t('rules.numberOfPieces')"></el-input>
          </el-form-item>
        </div>
        <div>
          <div class="formLabel">{{$t('base.unitPrice')}}</div>
          <el-form-item prop="CustomCommodityPrice">
            <el-input class="newTaxInput taxDeclaration" v-model="passForm.CustomCommodityPrice" oninput="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')" :placeholder="$t('rules.priceInDollars')"></el-input>
          </el-form-item>
        </div>

          <template v-if="isWW">
        <div>
          <div class="formLabel">{{$t('base.name')}}</div>
          <el-form-item prop="Name">
            <el-input class="newTaxInput taxDeclaration" v-model="passForm.Name" :placeholder="$t('rules.enterName')"></el-input>
          </el-form-item>
        </div>
        <div>
          <div class="formLabel">{{$t('base.IDnumber')}}</div>
          <el-form-item prop="IDNumber">
            <el-input class="newTaxInput taxDeclaration" v-model="passForm.IDNumber" :placeholder="$t('rules.IDnumber')"></el-input>
          </el-form-item>
        </div>
        </template>
        <!-- <div>
          <div class="formLabel">{{$t('base.countryOfOrigin')}}</div>
          <el-form-item prop="CustomOriginNation">
            <el-select  class='newTaxInput taxDeclaration' v-model="passForm.CustomOriginNation" filterable :placeholder="$t('rules.pleaseSelect')">
              <el-option-group v-for="(group,index) in nationCode" :key='index' :label="group.Initial">
                <el-option v-for="item in group.Data" :key="item.CountryNameEN" :label="item.CountryNameEN" :value="item.CountryNameEN"></el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
        </div> -->
      </el-form>
  </div>

      <div class="informationBox">
        <p class="text_gray small_text">{{$t('alert.taxDeclarationAlert')}}</p>
        <p v-if="isWW" class="text_gray small_text">{{$t('alert.EZWAY')}}</p>
        <span class="text_blue cursor" @click="realColumn">{{$t('base.viewRealColumn')}}</span>
      </div>
  <div class="flex_layout_between informationButton">
    <dl>
      <!-- <dt>{{$t('base.Total')}} <span class="text_red">{{passForm.CustomCommodityCount?passForm.CustomCommodityCount:0}}</span></dt> -->
      <dt>{{$t('base.Total')}} <span class="text_red">{{agencyCount}}</span></dt>
      <dd>{{$t('base.transshipmentSpecification')}}<span class="icon_process cursor" @click="ShippingFee()"></span></dd>
    </dl>
    <div><el-button type="primary" @click="submitForm('passForm')" style="width:230px;">{{$t('base.transitOrder')}}</el-button></div>
  </div>
  </el-dialog>
<get-weight title="" :domVisible='dislogType.weight' :list="dislogData" :dialogClass="'weight alertWeightList'" @closeDialog="closeDialog" v-if='dislogType.weight' />
    <get-address v-if="dislogType.commodityaddress" :dialogVisible.sync="dislogType.commodityaddress" :myAddress='myAddress' :isNew='isNew' @closeDialog="closeDialog" :userInfo.sync="userInfo" />
    </div>
</template>

<script>
import { getInfo,addressList,setInfo } from "@/api/public";
//import nationCode from "@/api/nationCode";
import GetAddress from "@/components/dialog/commodityaddress"; // 收货地址
import GetWeight from "@/components/dialog/weight"; // 稱重
export default {
  name: '',
  components: {
    GetAddress,
    GetWeight
  },
  data() {
    return {
      dislogType: this.$enumInfo.dislogType,
      userInfo:null,
      areaSymbol: this.$store.state.areaSymbol,
      dislogData:{},
      address:[],
      isAddressId:'',
      myAddress:'',
      loading:'',
      isNew:false,
      isWW:false,//是不是台湾账号
      //nationCode:nationCode.nationCode,
      passForm:{
        CustomDetail:'Card',
        CustomCommodityCount:'',
        CustomCommodityPrice:'',
        Name:'',
        IDNumber:''
      },
      rules: {
        CustomCommodityCount: [
          { required: true, message: this.$t('rules.numberOfPieces'), trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: " ", trigger: 'blur' },
        ],
        CustomCommodityPrice: [
          { required: true,message: this.$t('rules.priceInDollars'), trigger: 'blur' },
          { pattern:/^[1-9]\d*(\.\d+)?|0\.\d*[1-9]$/,message: " ", trigger: 'blur'}
        ],
        // CustomOriginNation: [
        //   { required: true, message: this.$t('rules.pleaseSelect'), trigger: 'change' },
        // ],
      }
    }
  },
  props: {
    list: {},
    dialogClass: '',
    title: "",
    agencyCount:0,
    agencyCode:'',
    dialogVisible: Boolean,
  },
  watch: {},
  mounted() {},
  created() {
    this.userInfo = getInfo();
    this.getAddressList()
    this.contrastMemberSource();
  },
  methods: {
    contrastMemberSource(){
      let that = this
      let MemberSource=that.userInfo.MemberSource;
      let agencyCode=that.agencyCode
      if(MemberSource&&(MemberSource=='TWN'||MemberSource=='TW')){
        let agencyRules='CN,TWN,TW,MO,HK'
        if(agencyRules.indexOf(agencyCode)>-1){
          that.rules.Name=[{ required: true, message: this.$t('rules.enterName'), trigger: 'blur' }]
          that.rules.IDNumber=[{ required: true, message: this.$t('rules.IDnumber'), trigger: 'blur' }]
          that.isWW=true;
      }else{
        that.rules.Name=""
        that.rules.IDNumber=""
        that.isWW=false
      }
    }
    },
    //获取收货地址
    getAddressList() {
      let that = this
      addressList().then(res => {
        setInfo('Count', res.Count ? res.Count : 0)
        if (res.Result) {
          that.address = res.Data
          that.myAddress=res.Data[0]
          if(!that.isAddressId){
            that.isAddressId=that.myAddress.Id
          }  
        }
      })
    },

    showAddress(obj){
      let StreetAddress=obj.StreetAddress+','
      let StreetAddress2=obj.StreetAddress2+','
      let City=obj.City+','
      let StateCode=obj.StateCode+','
      let ZipCode=obj.ZipCode
      return StreetAddress+StreetAddress2+City+StateCode+ZipCode
    },

    addChange(obj, val) {
      let that=this
      that.isNew=false
      if(val=='new'){
        that.isNew=true
      }
      that.dislogType.commodityaddress=true
    },

    submitForm(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        console.log(valid,'valid')
        if (valid) {
          that.closeDialog('close')
        }
      })
    },
    realColumn(){
        let html="<img src='/static/images/Viewrealcolumn.jpg' style='width: 100%;' />"
        this.$alert(html, '', {
          dangerouslyUseHTMLString: true,
          showConfirmButton:false
        });
    },
    ShippingFee() {
      // 价格列表
      let that = this
      //that.loading = true;
      let data = { pageIndex: 1, pageSize: 99, region: that.userInfo.MemberSource, agencyId: that.agencyCode}
      that.dislogData=data
      that.dislogType.weight = true;
    },
    closeDialog(val) {
      let that = this
      let isbol=false
      let newData='';
      if(val=='close'){
        isbol=true
        newData=that.passForm
        let address = {
          AddressId: that.myAddress.Id,
          Consignee: that.myAddress.UserName,
          Mobile: that.myAddress.Phone,
          ZipCode: that.myAddress.ZipCode,
          //Provice: AddressDetail.StateCode,
          Provice: that.myAddress.State,
          City: that.myAddress.City,
          AddressDetail: that.myAddress.StreetAddress + (that.myAddress.StreetAddress2 ? '(' + that.myAddress.StreetAddress2 + ')' : ''),
          Nation: that.myAddress.Country
        }
        newData={...newData,Address:address}
        this.$emit('closeDialog', 'taxDeclaration', false,newData,isbol)
      }else if(val=='commodityaddress'){
        this.dislogType.commodityaddress=false
        this.getAddressList()
      }else if(val=='weight'){
        this.dislogType.weight=false
      }else{
        this.$emit('closeDialog', 'taxDeclaration', false,newData,isbol)
      }
      
    },
  },
  destroyed() {
    //this.closeDialog()
  }
}

</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.checkout_box{
  margin-bottom: 10px;
}
.checkout_box h3 {
  font-size: 24px;
  line-height: 1;
  margin: 0 0 16px;
  display: flex;
  font-weight: normal;
}

.checkout_box h3>span {
  font-size: 14px;
  margin-top: 9px;
  margin-left: 12px;
  cursor: pointer;
}
.address_list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
        height: 130px;
    overflow-y: auto;
}
.address_list li {
  height: auto;
  border: 2px dashed #e0e0e0;
  padding: 0;
  min-height: 120px;
  width: 278px;
  position: relative;
  cursor: pointer;
}

.address_list li>.choose_address {

  box-sizing: border-box;
  padding: 10px;
  width: 100%;
  padding-bottom: 10px
}
.choose_address>div {
  margin-bottom: 10px;
}
.address_list li.on{
  border-color: #5f6dae;
}
.address_list li.on:before{
      content: "";
    border: 1px solid #fff;
    border-top: none;
    border-left: none;
    width: 4px;
    height: 10px;
    position: absolute;
    transform: rotate(45deg);
    bottom: 3px;
    right: 5px;
    z-index: 2;
}
.address_list li.on::after {
    content: "";
    border: 15px solid transparent;
    position: absolute;
    border-bottom-color: #5f6dae;
    border-right-color: #5f6dae;
    right: -2px;
    bottom: -2px;
  }
.address_list li.on .change {
  position: absolute;
  z-index: 2;
  right: 12px;
  bottom: 24px;
  font-size: 14px;
  margin: 0;
  left: auto;
}


.parcelInformation{
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.formTitle{
  margin-bottom: 24px;
  font-weight: 700;
}
.formLabel{
  margin-bottom: 12px;
}
.informationBox{
  overflow: hidden;
  border-top:1px solid #e0e0e0;
  margin-top: 10px;
}
.informationBox p{
  margin: 9px 0 10px;
}
.informationButton{
  margin-top: 20px;
}
.informationButton dd{
  margin-top: 5px;
  display: flex;
  align-items: center;
}

.icon_process{
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url(/static/images/icon/icon_oversea_question.svg);
    margin-left: 5px;
}


</style>



// WEBPACK FOOTER //
// src/components/dialog/taxDeclaration.vue